<script>
	import { createEventDispatcher } from 'svelte'
	
	export let active
	export let mobile
	export let thisPage
	export let otherModels = []
	
	let animate = false

	const dispatch = createEventDispatcher()
	const toggleActive = async() => {
		animate = true
		const newActive = active === otherModels[0] ? otherModels[1] : otherModels[0]

		dispatch('newActive', newActive)
		await sleep(369)

		animate = false
	}
	const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
</script>

<div class="header" class:mobile>
	{#if mobile}
		<div class="model active">{thisPage}</div>
		<div class="model">{active}</div>
		<div class="toggle" on:click={toggleActive}>
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 492.883 492.883" xml:space="preserve" style="width: 1em; height: 1em" class:animate={animate}>
				<polyline points="304 48 416 160 304 272" class="arrow right" />
				<line x1="398.87" y1="160" x2="96" y2="160" class="arrow right" />
				<polyline points="208 464 96 352 208 240" class="arrow left" />
				<line x1="114" y1="352" x2="416" y2="352" class="arrow left" />
			</svg>
		</div>
	{:else}
		<div class="model"></div>
		<div class="model active">{thisPage}</div>
	
		{#each otherModels as model}
			<div class="model">
				{model}
			</div>
		{/each}
	{/if}
</div>

<style>
	.header {
		display: flex;
		font-size:2em;
		text-transform: uppercase;
		position: relative;
		width: 100%;
		position: sticky;
		top:0;
		background: var(--darker);
		color: var(--white);
		z-index: 99;
	}
	.header .model {
		text-align: center;
		padding: 0.382em 1em;
		width: 25%;
	}
	.header .model.active {
		font-weight: bold;
		text-decoration: underline;
	}
	.header.mobile .model {
		width: 50%;
	    text-align: left;
	    padding: 0.382em 0.3em;
	}
	.toggle {
		position: absolute;
		top: 0.3em;
		right: 0.3em;
		cursor: pointer;
	}
	.arrow {
		fill:none;
		stroke:var(--white);
		stroke-linecap:round;
		stroke-linejoin:round;
		stroke-width:32px
	}

	svg.animate .left {
		animation: moveRight 369ms ease-in-out;
	}
	svg.animate .right {
		animation: moveLeft 369ms ease-in-out;
	}
	@keyframes moveLeft {
		0% {
			transform: translateX(0);
			opacity: 1;
		}
		100% {
			transform: translateX(-90px);
			opacity: 0.5;
		}
	}
	@keyframes moveRight {
		0% {
			transform: translateX(0);
			opacity: 1;
		}
		100% {
			transform: translateX(90px);
			opacity: 0.5;
		}
	}
</style>